import React from "react";
import { BreadcrumbContainer, BreadcrumbItem } from "./styles";

export interface IBreadcrumbLink {
    name: string;
    path: string;
    active?: boolean;
}

interface IProps {
    links: IBreadcrumbLink[];
}

const Breadcrumb = ({ links }: IProps) => {
    if (!Array.isArray(links) || !links.length) {
        return null;
    }

    return (
        <BreadcrumbContainer>
            {links.map((link) => (
                <BreadcrumbItem
                    to={link.path}
                    active={!!link.active}
                    key={link.name}
                >
                    {link.name}
                </BreadcrumbItem>
            ))}
        </BreadcrumbContainer>
    );
};

export default React.memo(Breadcrumb);
